import payment from "./factories/DefaultPaymentGateway";
appHost.plugins.register({
    // #region Vars
    name: "288a.payment.core",
    // #endregion
    // #region register
    register() {
        appHost.provider.register('PAYMENT', 'system', new payment());
    }
    // #endregion
});
